export default {
  methods: {
    formatDate(date) {
      if (date) {
        return this.$moment(date).format("YYYY-MM-DD")
      }
      return null
    }
  }
}
